module.exports = "/_next/static/images/profile 1-14705480d98a1d94e86d349fb0627670.svg";